@use '../../styles/Constants.scss' as Constants;

.time-settings-inputs > :global(.row){
	padding-left: 0;
}

.dropdown-option {
	white-space: nowrap;
	min-width: 220px;

	& + div {
		margin-left: Constants.$val-spacing-s;
	}
}